import { VehicleSearchParams } from 'interface';
import { SEARCHQUERY } from './searchquery';

export const ROOT = '/';
export const PAGE_NAME = window.GLOBAL_STATE.configure.pageName
  ? window.GLOBAL_STATE.configure.pageName
  : 'configure';

export const CONFIGURE = `/${PAGE_NAME}`;
export const CUSTOMISE = `/${PAGE_NAME}/customise`;
const REDIRECTCONFIGURATOR = `?redirectUrl=/${PAGE_NAME}`;

export const CONFIGURE_SEARCH = (searchParams: VehicleSearchParams) => {
  return `${CONFIGURE}?${SEARCHQUERY(searchParams)}`;
};
export const CUSTOMISE_SEARCH = (searchParams: VehicleSearchParams) => {
  return `${CUSTOMISE}?${SEARCHQUERY(searchParams)}`;
};
export const LOGIN = `/login${REDIRECTCONFIGURATOR}`;
export const REGISTER = `/register${REDIRECTCONFIGURATOR}`;
export const VERIFY = `/verify${REDIRECTCONFIGURATOR}`;
export const SHORTLIST = '/shortlist';
export const AUTHENDPOINT = 'api/accountsapi/LoginAuth';
export const getVehicleSearchURL = (make: string) =>
  `${window.GLOBAL_STATE.configure.searchPage}/make/${make}`;
